module.exports = __webpack_public_path__ + "static/media/DSC_5739.2f3e7272.jpg";